import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api } from "@/lib/api";

const campaignKey = (campaign) => `spicy3d_campaign_${campaign.id}`;

function LeadCapture({ campaign, onDone }) {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [consent, setConsent] = useState(false);
  const [status, setStatus] = useState("");
  if (!campaign.collect_email && !campaign.collect_phone) return null;
  const submit = async (event) => {
    event.preventDefault();
    try { await api.post("/marketing/leads", { email, phone, consent, campaign_id: campaign.id }); setStatus("Thanks — you’re on the list."); onDone(); } catch (error) { setStatus(error?.response?.data?.detail || "Please confirm consent and a contact method."); }
  };
  return <form onSubmit={submit} className="store-campaign-lead"><div>{campaign.collect_email && <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email address" type="email" />}{campaign.collect_phone && <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone number" type="tel" />}</div><label><input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} /> I agree to receive marketing messages.</label><button type="submit">Join</button>{status && <small>{status}</small>}</form>;
}

export default function CampaignLayer() {
  const [campaigns, setCampaigns] = useState([]);
  const [openPopup, setOpenPopup] = useState(null);

  useEffect(() => {
    api.get("/campaigns").then((r) => {
      setCampaigns(r.data);
      const popup = r.data.find((campaign) => {
        if (campaign.type !== "popup") return false;
        const last = Number(localStorage.getItem(campaignKey(campaign)) || 0);
        return Date.now() - last >= campaign.frequency_days * 86400000;
      });
      if (popup) setOpenPopup(popup);
    }).catch(() => {});
  }, []);

  const closePopup = () => {
    if (openPopup) localStorage.setItem(campaignKey(openPopup), String(Date.now()));
    setOpenPopup(null);
  };
  const banners = campaigns.filter((campaign) => campaign.type === "banner");

  return <>{banners.map((campaign) => <a key={campaign.id} href={campaign.link} className="store-campaign-banner" style={{ "--campaign-accent": campaign.accent }} data-testid={`store-banner-${campaign.id}`}><span>{campaign.title}</span>{campaign.body && <small>{campaign.body}</small>}{campaign.discount_code && <b>{campaign.discount_code}</b>}</a>)}{openPopup && <div className="store-campaign-popup" data-testid={`store-popup-${openPopup.id}`}><div className="store-campaign-popup-card" style={{ "--campaign-accent": openPopup.accent }}>{openPopup.image_url && <img src={openPopup.image_url} alt="" /> }<button onClick={closePopup} aria-label="Close promotion" data-testid="store-popup-close"><X size={18} /></button><p>{openPopup.title}</p>{openPopup.body && <span>{openPopup.body}</span>}{openPopup.discount_code && <strong>{openPopup.discount_code}</strong>}<LeadCapture campaign={openPopup} onDone={closePopup} /><a href={openPopup.link} onClick={closePopup}>{openPopup.button_text}</a></div></div>}</>;
}